import { DistributionChartCore, DistributionChartCoreProps } from "./DistributionChartCore";
import { ScoreDetailBuilder } from "src/context/ScoreDetail/ScoreDetailBuilder";
import { Post } from "src/api/client-api/post/postSchema";
import { useEffect, useState } from "react";
import { DimensionValue } from "src/api/client-api/olapScores/olapScoresSchema";
import { DrilldownState } from "src/context/ScoreDetail/useDrilldown";
import { GetOnePost } from "src/api/client-api/post/useGetOnePost";
import { SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion.ts";

type DistributionChartProps = DistributionChartCoreProps & {
    ssqVersion?: SsqVersion;
};
export const DistributionChart = (props: DistributionChartProps) => {
    const { olapScores, ssqVersion, fetchPostForAnswers, openModal } = props;

    const [post, setPost] = useState<Post | GetOnePost | undefined>(undefined);

    useEffect(() => {
        if (!fetchPostForAnswers || !ssqVersion) return;

        fetchPostForAnswers().then((response) => {
            setPost(response.data);
        });
    }, [fetchPostForAnswers, ssqVersion]);

    const showPropertyModal = (dimension: string, dimensionValue: DimensionValue, drilldownState: DrilldownState[]) => {
        if (!ssqVersion || !post) return;

        const scoreDetailBuilder = new ScoreDetailBuilder({ ssqVersion, post, olapScores });

        if (!openModal || (dimension !== "properties" && dimension !== "subproperties")) return;

        const drilldownHeadingId = drilldownState.find((state) => state.type === "headings")?.id;
        const drilldownSubheadingId = drilldownState.find((state) => state.type === "subheadings")?.id;
        const drilldownPropertyId = drilldownState.find((state) => state.type === "properties")?.id;

        const headingId = drilldownHeadingId ? Number(drilldownHeadingId) : undefined;
        const subheadingId = drilldownSubheadingId ? Number(drilldownSubheadingId) : undefined;
        const propertyId = drilldownPropertyId ? Number(drilldownPropertyId) : undefined;

        const targetPropertyId = dimension === "subproperties" ? propertyId : Number(dimensionValue.id);

        if (!headingId || !targetPropertyId) return;

        const builderProperty = scoreDetailBuilder.getByPropertyId({
            headingId,
            subheadingId,
            propertyId: targetPropertyId,
        });

        if (!builderProperty) return;

        openModal(builderProperty.property);
    };

    return <DistributionChartCore onLastLevelClick={showPropertyModal} {...props} />;
};
